import { Button, FormControl, Input, InputLabel, MenuItem, Select } from '@material-ui/core';
import moment from 'moment';

const ActivityForm = ({
    activity,
    timeslots,
    selectTimeslot,
    selectedTimeslot,
    checkInDate,
    groupSize,
    addToCart,
    userRole
}) => {
    const uniqueTimeslots = timeslots
        ? [...new Set(timeslots.filter(e => !e.disabled).map(e => `${e.start_time},${e.end_time}`))]
        : false;
    const hasWarning =
        selectedTimeslot &&
        timeslots &&
        timeslots.find(e => `${e.start_time},${e.end_time}` === selectedTimeslot) &&
        timeslots.find(e => `${e.start_time},${e.end_time}` === selectedTimeslot).warning;

    if (!activity) {
        return null;
    }

    const fakeUniqueTimeslot = moment().format('ddd, MMM DD h:mm a');
    return (
        <>
            {checkInDate && groupSize ? (
                <div>
                    <h5>Available timeslots and tickets</h5>
                    {uniqueTimeslots && uniqueTimeslots.length > 0 ? (
                        <FormControl fullWidth>
                            <InputLabel>Timeslot</InputLabel>
                            <Select
                                className="input"
                                input={<Input id="select-time-and-date" fullWidth />}
                                value={selectedTimeslot || ''}
                                onChange={ev => selectTimeslot(ev.target.value)}
                            >
                                {uniqueTimeslots.sort().map(t => {
                                    const [start, end] = t.split(',');
                                    return (
                                        <MenuItem key={t} value={t}>
                                            {moment(start).format('ddd, MMM DD h:mm a')} -
                                            {moment(end).format('ddd, MMM DD h:mm a')}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    ) : (
                        <p>No possible dates found.</p>
                    )}
                    {hasWarning && (
                        <p>
                            <small>{hasWarning}</small>
                        </p>
                    )}
                </div>
            ) : (
                <div>
                    <p>
                        <h4>
                            Please select a checkin,checkout date and group size first to see the
                            available timeslots!
                        </h4>
                    </p>
                </div>
            )}
            {uniqueTimeslots && uniqueTimeslots.length > 0 && (
                <div>
                    <Button
                        disabled={!selectedTimeslot}
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const [start, end] = selectedTimeslot.split(',');
                            addToCart(start, end);
                        }}
                    >
                        Book now
                    </Button>
                </div>
            )}
            {userRole === 'agent' && (
                <div style={{ paddingTop: '10px' }}>
                    <Button
                        fullWidth
                        variant={
                            uniqueTimeslots && uniqueTimeslots.length > 0 ? 'text' : 'contained'
                        }
                        color="primary"
                        onClick={() => addToCart(fakeUniqueTimeslot)}
                    >
                        Do custom booking
                    </Button>
                </div>
            )}
        </>
    );
};

export default ActivityForm;
